import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class CanActivateResearchService implements CanActivate {
  constructor(private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | Observable<boolean> | Promise<boolean> {
    if (sessionStorage.getItem('seen-research-intro')) {
      this.router.navigateByUrl('/centigrade/research/summary');
    }
    return true;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/guards/can-activate-research.service.ts